export const MAP_PROVIDERS = [
  { value: 'mapbox', label: 'Mapbox' },
  { value: 'google', label: 'Google Map' },
  { value: 'osm', label: 'OpenStreetMap' },
];

export const UNITS = [
  { value: 'metric', label: 'Metric (m, km, kg)' },
  { value: 'imperial', label: 'Imperial (ft, mi, lb)' },
];

export const TIMEZONES = [
  { value: 'pst', label: 'Pacific Standard Time (PST)' },
  { value: 'est', label: 'Eastern Standard Time (EST)' },
  { value: 'cst', label: 'Central Standard Time (CST)' },
  { value: 'mst', label: 'Mountain Standard Time (MST)' },
  { value: 'utc', label: 'Coordinated Universal Time (UTC)' },
];
